import { Insurance, InsuranceFormData, InsuranceFormDataApi, InsuranceFormErrors, InsuranceFormErrorsApi } from '../types'

export class InsuranceMappers {
  public static fromApi(raw: any): Insurance {
    return {
      id: raw.id,
      descr: raw.descr,
      name: raw.name,
      percent: raw.percent,
      stateId: raw.state_id,
    }
  }

  public static collectionFromApi(raw: any): Insurance[] {
    return raw.map((item) => InsuranceMappers.fromApi(item))
  }

  public static formDataToApi(formData: InsuranceFormData): InsuranceFormDataApi {
    return {
      descr: formData.descr,
      name: formData.name,
      percent: formData.percent,
      insurance_id: formData.id,
      state_id: formData.stateId,
    }
  }
  public static formErrorsFromApi(errors: InsuranceFormErrorsApi): InsuranceFormErrors {
    return {
      descr: errors.descr?.join(', '),
      name: errors.name?.join(', '),
      percent: errors.percent?.join(', '),
      id: errors.insurance_id?.join(', '),
      stateId: errors.state_id?.join(', '),
    }
  }
  public static formInitializer(insurance: Insurance): InsuranceFormData {
    return {
      descr: insurance.descr,
      name: insurance.name,
      percent: insurance.percent,
      stateId: insurance.stateId.toString(),
      id: insurance.id,
    }
  }
}
